<template>
	<section v-if="props" class="hero hero-center hero-works-detail" :class="{heroHome : heroHome}">
		<!-- <a href="#" class="arrow-down" v-in-viewport="{}" v-scroll-to="'#section'"></a> -->
		<div v-if="(props.background_video___desktop.value) && (!this.$breakpoints.isMobile())" class="hero-video-mask">
			<div class="overlay-gradient" ></div>
			
			<div class="hero-title-container">
				<div class="container" :class="{'text-center' : heroHome }">

					<h1 class="headline" v-if="props.header_title" v-in-viewport="{}">
						<span class="splitted" id="splitWord"></span>
						{{props.header_title.value}}
					</h1>
					<h3 class="subheadline" v-if="props.header_description" v-in-viewport="{}">{{props.header_description.value}}</h3>
				</div>
			</div>
			<span class="toTop" ref="toTop"></span>
		</div>

		<div v-else="this.$breakpoints.isMobile()" class="hero-image-mask">
			<div class="hero-title-container">
				<div class="container" :class="{'text-center' : heroHome }">

					<h3 class="subheadline" v-if="props.header_description" v-in-viewport="{}">{{props.client.value[0].name}}</h3>

					<h1 class="headline" v-if="props.header_title" v-in-viewport="{}">
						<span class="splitted" id="splitWord"></span>
						{{props.header_title.value}}
					</h1>
					
				</div>
			</div>
			<template v-if="props.background_image___desktop.value" class="">
				<!-- <div class="overlay-gradient"></div>
				<div v-if="props.background_image___desktop.value[0]" class="hero-image hidden-xs " :style="setBackgroundImage(props.background_image___desktop.value[0].url)"></div>
				<div v-if="props.background_image___mobile.value[0]" class="hero-image hidden-sm" :style="setBackgroundImage(props.background_image___mobile.value[0].url)"></div> -->
			</template>
		</div>
	</section>
</template>


<script>
	require('../assets/img/arrow-down.svg');

	import commons from '../mixins/common.js';

	export default{
		name:'Hero',
		props: ['props', 'heroHome','splitted','auxIndex'],
		mixins:[commons],
		computed:{
			animatedWord: function(){
				if (typeof this.props !== 'undefined'){
					if (typeof this.props.animated_words_for_header_title !== 'undefined'){
						let str = this.props.animated_words_for_header_title.value;
	 				 	return str.split(',');
					}
				}
			}
		},
		mounted:function(){
			if (typeof this.props !== 'undefined'){
				 if (typeof this.props.animated_words_for_header_title !== 'undefined'){
					 this.animateWords();
				 }
			 }
		},
		methods:{
			animateWords: function(){
				for (var i=0; i < this.animatedWord.length; i++){
					var node = document.createElement('b');
					node.insertAdjacentHTML( 'beforeend', this.animatedWord[i] );
					document.getElementById('splitWord').appendChild(node);
				}

				var numberOfItems = this.animatedWord.length;
				var currentItem = 0;

				//show first item
				$('.splitted b').removeClass('is-visible');

				//loop through the items
				var infiniteLoop = setInterval(function(){
					$('.splitted b').removeClass('is-visible');

					if(currentItem == numberOfItems -1){
						currentItem = 0;
					}else{
						currentItem++;
					}
					//$('.splitted b').removeClass('is-visible');
					$('.splitted b').eq(currentItem).addClass('is-visible');
				}, 3000);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// hero-works.vue?16e4bda5